/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiChSettingsDto } from '../models/AiChSettingsDto';
import type { AiChSettingsUpdateRequest } from '../models/AiChSettingsUpdateRequest';
import type { SuggestionsDecisionDto } from '../models/SuggestionsDecisionDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AiChattingService {
    /**
     * Get AI CHatting Settings
     * Get AI Chatting settings (or create default and get if not exists
     * @returns AiChSettingsDto Successfully returned settings dto
     * @throws ApiError
     */
    public static getAiChSettings({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<AiChSettingsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/aich/{creatorId}/settings',
            path: {
                'creatorId': creatorId,
            },
            errors: {
                401: `Unauthorized user`,
                403: `Invalid Creator or User permissions or feature is not enabled`,
            },
        });
    }
    /**
     * Update AI CHatting Settings
     * Update AI Chatting settings (toggle enabled/disabled for now)
     * @returns AiChSettingsDto Successfully returned settings dto
     * @throws ApiError
     */
    public static updateAiChSettings({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        /**
         * Update request DTO
         */
        requestBody: AiChSettingsUpdateRequest,
    }): CancelablePromise<AiChSettingsDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/aich/{creatorId}/settings',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized user`,
                403: `Invalid Creator or User permissions or feature is not enabled`,
            },
        });
    }
    /**
     * Trigger suggestion regeneration
     * Trigger AI bot to generate new suggestion for the chat
     * @returns any Request successfully accepted
     * @throws ApiError
     */
    public static regenerateSuggestion({
        creatorId,
        ofCreatorId,
        ofFanId,
        requestBody,
    }: {
        creatorId: number,
        ofCreatorId: number,
        ofFanId: number,
        requestBody?: any,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/aich/{creatorId}/suggestions/{ofCreatorId}/{ofFanId}/regenerate',
            path: {
                'creatorId': creatorId,
                'ofCreatorId': ofCreatorId,
                'ofFanId': ofFanId,
            },
            body: requestBody,
            errors: {
                401: `Unauthorized user`,
                403: `Invalid Creator or User permissions or feature is not enabled`,
            },
        });
    }
    /**
     * Mark suggestion as accepted and push feedback
     * Mark proposed suggestion as accepted to invalidate it on BE side and push feedback to the bot side
     * @returns any Request successfully accepted
     * @throws ApiError
     */
    public static markSuggestionAccepted({
        creatorId,
        ofCreatorId,
        ofFanId,
        requestBody,
    }: {
        creatorId: number,
        ofCreatorId: number,
        ofFanId: number,
        /**
         * Chatter feedback dto
         */
        requestBody: SuggestionsDecisionDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/aich/{creatorId}/suggestions/{ofCreatorId}/{ofFanId}/accept',
            path: {
                'creatorId': creatorId,
                'ofCreatorId': ofCreatorId,
                'ofFanId': ofFanId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized user`,
                403: `Invalid Creator or User permissions or feature is not enabled`,
            },
        });
    }
    /**
     * Request AI CHatting Suggestions
     * Request AI CHatting Suggestions by OF creatorID and OF fanId
     * @returns any Request successfully accepted
     * @throws ApiError
     */
    public static getAiChSuggestions({
        creatorId,
        ofCreatorId,
        ofFanId,
    }: {
        creatorId: number,
        ofCreatorId: number,
        ofFanId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/aich/{creatorId}/suggestions/{ofCreatorId}/{ofFanId}',
            path: {
                'creatorId': creatorId,
                'ofCreatorId': ofCreatorId,
                'ofFanId': ofFanId,
            },
            errors: {
                401: `Unauthorized user`,
                403: `Invalid Creator or User permissions or feature is not enabled`,
            },
        });
    }
}
